<div class="app-mian-header">
  <div class="header-inner">
    <div class="menu-toggle" (click)="toggelSidebar()">
      <img src="assets/images/icons/minimize-sidebar.svg" alt="">
    </div>
    <div class="logo-mobile">
      <img src="./assets/images/logos/cpa-logo-white.svg">
    </div>
    <div class="header-actions">
      <a class="btn btn-lang" (click)="changeLanguage()">
        {{ 'general.language' | translate }}
      </a>
      <p class="orange-color font-14 ml-2 text-nowrap"
        *ngIf="actionsPermissions?.currentRestaurantAction?.attendancefeature">
        {{"auth.Clock-In" | translate}}:
        <span class="fontSemiBold">
          {{actionsPermissions.currentRestaurantAction?.lastClockIn | date:'d MMM y - h:mm a'}}
        </span>
      </p>
    </div>
    <div class="header-part-right">
    <div class="elementor-widget-container">
        <div class="notification-btn dropdown-container" appDropDown>
          <span (click)="openNotificationPanel()">
            <span class="notification-count">{{ notificationsResult.unSeenNotificationsCount }}</span>
            <img src="./assets/images/icons/notifications-icon.svg"
              [ngClass]="{swing: notificationsResult.unSeenNotificationsCount}">
          </span>
          <div class="notification-panel dropdown-inner-menu">
            <div class="notification-header">
              <h3>{{ 'general.Notification' | translate }}</h3>
            </div>

            <div class="notifications-wrapper">
              <div *ngIf='notifLoading' class="dataLoading py-5">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
              <ng-container *ngIf="!notifLoading">
                <div class="no-data text-center d-flex align-items-center justify-content-center h-100 px-2 py-5" *ngIf="!notificationsList.length">
                  {{ 'general.You have no notifications' | translate }}!
                </div>
                <div *ngIf="notificationsList.length">
                  <div class="notification-list" infiniteScroll [scrollWindow]="false"
                  [infiniteScrollDistance]="2" [infiniteScrollThrottle]="pageCount" (scrolled)="getNextPage()">
                  <div *ngFor="let notif of notificationsList" [ngClass]="notif.isSeen ? '':'new'"  (click)="seeNotifications(notif)">
                    <ng-container [ngSwitch]="notif?.notificationType">
                      <a *ngSwitchCase="'NEW_RIGHT_FOR_REVIEW'" [routerLink]="['/admin/rights/details' , notif.objectId]">
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'RIGHT_UPDATED'"  [routerLink]="['/admin/rights/details' , notif.objectId]">
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                      <a *ngSwitchCase="'TICKET_UPDATED'"  [routerLink]="['/admin/complaints' , notif.objectId]">
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>

                      <a *ngSwitchDefault>
                        <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                      </a>
                    </ng-container>
                  </div>
                </div>
                  <!-- <cdk-virtual-scroll-viewport class="notification-list" [itemSize]="10" (scrolledIndexChange)="getNextPage($event)">
                      <div *cdkVirtualFor="let notif of notificationsList" [ngClass]="{new: !notif?.isSeen}" (click)="notificationMenu = false">

                    </div>
                  </cdk-virtual-scroll-viewport> -->
                  <div *ngFor="let notif of notificationsList" [ngClass]="{new: !notif?.isSeen}" (click)="notificationMenu = false">
                  </div>
                </div>
              </ng-container>
            </div>

          </div>
        </div>
    </div>

      <div class="elementor-widget-container">
        <div *ngIf="currentUser" class="userAccount dropdown-container m-0" id="userAccountDrop" appDropDown>
          <div class="dropdown-toggler d-flex align-items-center">
            <div class="profile-image">
              <img *ngIf="currentUser.ImagePath" [src]="currentUser.ImagePath" (error)="currentUser.ImagePath = ''" />
              <span *ngIf="!currentUser.ImagePath" [innerHTML]="currentUser.FullName | shortName"></span>
            </div>
            <div class="user-name">
              <span class="mr-2"> {{ 'general.Hello' | translate }}, {{currentUser.FullName}}</span>
            </div>
          </div>

          <div class="custom-dropdown-menu dropdown-inner-menu" [class.moveX]="currentUser.UserType == userType.INSTITUTION_USER || currentUser.UserType == userType.INSTITUTION_ADMIN">
            <ul>
              <!-- [routerLink]="['profile']" -->
              <li
                *ngIf="currentUser.UserType == userType.INSTITUTION_USER || currentUser.UserType == userType.INSTITUTION_ADMIN">
                <a [routerLink]="['entities/entityProfile']">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                    <path id="ic_company_profile_filled"
                      d="M6.75,0h-3A3.75,3.75,0,0,0,0,3.75v10.5A3.75,3.75,0,0,0,3.75,18H10.5V3.75A3.75,3.75,0,0,0,6.75,0Zm-3,14.25H3a.75.75,0,0,1,0-1.5h.75a.75.75,0,1,1,0,1.5Zm0-3H3a.75.75,0,0,1,0-1.5h.75a.75.75,0,0,1,0,1.5Zm0-3H3a.75.75,0,1,1,0-1.5h.75a.75.75,0,1,1,0,1.5Zm0-3H3a.75.75,0,0,1,0-1.5h.75a.75.75,0,1,1,0,1.5Zm3.75,9H6.75a.75.75,0,1,1,0-1.5H7.5a.75.75,0,0,1,0,1.5Zm0-3H6.75a.75.75,0,1,1,0-1.5H7.5a.75.75,0,0,1,0,1.5Zm0-3H6.75a.75.75,0,1,1,0-1.5H7.5a.75.75,0,0,1,0,1.5Zm0-3H6.75a.75.75,0,1,1,0-1.5H7.5a.75.75,0,0,1,0,1.5Zm6.75-1.5H12V18h2.25A3.755,3.755,0,0,0,18,14.25V7.5a3.755,3.755,0,0,0-3.75-3.75ZM15,14.25a.75.75,0,1,1,.75-.75A.75.75,0,0,1,15,14.25Zm0-3a.75.75,0,1,1,.75-.75A.75.75,0,0,1,15,11.25Zm0-3a.75.75,0,1,1,.75-.75A.75.75,0,0,1,15,8.25Z"
                      fill="#8E8FA2" />
                  </svg>
                  {{ 'profile.entityAccountManagement' | translate }}
                </a>
              </li>
              <li><a [routerLink]="['user-profile']">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="18" viewBox="0 0 13.5 18">
                      <path id="ic_user"
                        d="M.75,18A.75.75,0,0,1,0,17.25a6.75,6.75,0,1,1,13.5,0,.75.75,0,0,1-.75.75ZM2.25,4.5A4.5,4.5,0,1,1,6.75,9,4.5,4.5,0,0,1,2.25,4.5Z"
                        fill="#8E8FA2" />
                    </svg>
                  </span>
                  {{ 'profile.accountManagement' | translate }}
                </a>
              </li>
              <!--<li hidden><a [routerLink]="['changepassword']">
                  <svg width="14" height="17" viewBox="0 0 14 17">
                    <path id="my-profile-icon"
                      d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z"
                      fill="#999999" />
                  </svg>{{ 'general.Update password' | translate }}
                </a></li> -->
              <li>
                <a (click)="logout()">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                      <path id="ic_log_out"
                        d="M16173.752,16742a3.755,3.755,0,0,1-3.751-3.75v-10.5a3.755,3.755,0,0,1,3.751-3.75h1.5a.75.75,0,0,1,0,1.5h-1.5a2.251,2.251,0,0,0-2.251,2.25v10.5a2.251,2.251,0,0,0,2.251,2.25h1.5a.75.75,0,0,1,0,1.5Zm9.382-3.969a.75.75,0,0,1,.019-1.061l2.91-2.91a1.5,1.5,0,0,0,.25-.346.518.518,0,0,1-.059.012l-11.761.023a.75.75,0,0,1,0-1.5l11.766-.023c.011,0,.021.006.031.006a1.556,1.556,0,0,0-.225-.293l-2.91-2.908a.75.75,0,0,1,1.061-1.061l2.91,2.908h0a3,3,0,0,1,0,4.242l-2.91,2.91-.019.018a.75.75,0,0,1-1.061-.018Z"
                        transform="translate(-16169.501 -16723.502)" fill="#8e8fa2" stroke="rgba(0,0,0,0)"
                        stroke-miterlimit="10" stroke-width="1" />
                    </svg>
                  </span>
                  {{ 'general.Logout' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notifContent let-notif="notif">
  <p class="title">{{notif?.text}}</p>
  <span class="date">
    {{notif?.date | timeAgo}}
  </span>
</ng-template>
